export const RED_TESTING_CONFIG = {
  experiments: []
}
